import type { BrandId, DocsAccessDocument } from '@nadoutong/contracts';
import { platformApiRequest } from './client.ts';

/**
 * Brand this console pins on every docs-access query — the same pin
 * `status.ts` and `useCatalog.ts` already use. The renderer never reads
 * this: it draws whatever document the endpoint returned.
 */
const DOCS_ACCESS_BRAND: BrandId = 'nxtpath';

/**
 * Display name substituted into `{{brand_name}}`. Kept next to the brand
 * pin so the renderer does not learn a product string.
 */
export const DOCS_ACCESS_BRAND_NAME = 'Nxtpath';

export const DOCS_ACCESS_QUERY_KEY = ['docs', 'access', DOCS_ACCESS_BRAND] as const;

/**
 * Session-gated `GET /v1/docs/access`. Brand is a query param the same
 * way `/v1/catalog/me` takes it — not derived from the session.
 */
export async function getDocsAccessDocument(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<DocsAccessDocument> {
  const params = new URLSearchParams({ brand: DOCS_ACCESS_BRAND });
  return platformApiRequest<DocsAccessDocument>(
    `/v1/docs/access?${params.toString()}`,
    { signal },
    fetchImpl,
  );
}
